<template>
  <div class="agri-service-cloud-container-mobile" v-if="isMobile">
    <HeaderH5 :platInfo="platInfo"></HeaderH5>
    <ScaleBox>
      <router-view :platInfo="platInfo" :isMobile="true"></router-view>
    </ScaleBox>
    <FooterH5 :platInfo="platInfo" v-if="!route.meta.FooterShow"></FooterH5>
  </div>
  <div class="agri-service-cloud-container" v-else>
    <Header :platInfo="platInfo" :themeColor="themeColor" @heightChange="headerHeightChange"></Header>
    <div class="agri-Contain"
      :style="{
        minHeight: `calc(100vh - ${headerHeight || 0}px - ${footerHeight || 0}px)`,
        paddingTop: `${headerHeight || 0}px`
      }">
      <router-view :themeColor="themeColor" :topHeight = 'headerHeight'></router-view>
    </div>
    <Footer :platInfo="platInfo" v-if="!route.meta.FooterShow" :themeColor="themeColor" @heightChange="footerHeightChange"></Footer>
    <footerHz v-else  :platInfo="platInfo"></footerHz>
    <floatingWidget :themeColor="themeColor" :platInfo="platInfo" v-if="floatShow"></floatingWidget>
  </div>
</template>
<script setup>
import { ref, getCurrentInstance, computed,watch,onMounted } from "vue";
import { useRoute } from 'vue-router';
import Header from "./header.vue"
import Footer from "./footer.vue"
import footerHz from "./footerHz.vue"
import floatingWidget from "./floatingWidget.vue"
import HeaderH5 from "./headerH5.vue"
import FooterH5 from "./footerH5.vue"
import ScaleBox from "./ScaleBox.vue"
const themeColor = ref('blue')
const route = useRoute();
const toReady = ref(route.meta?.mobileReady)
const props = defineProps({
    platInfo: {
        type: Object,
        default: {}
    }
})
const { proxy } = getCurrentInstance();
const floatShow = ref(proxy.getConfig().floatShow)
const headerHeight = ref(0)
const footerHeight = ref(0)
// const FooterShow=ref(true)

// if(route.meta.FooterShow==false){
//    FooterShow.value=route.meta.FooterShow;
// }else{
//    FooterShow.value=true;
// }


watch(
  () => route.meta,
  (newMeta, oldMeta) => {
    toReady.value = newMeta.mobileReady
    // 你可以在这里根据 meta 做权限控制、页面标题设置等
  },
  { immediate: true }
)
const headerHeightChange = (height) => {
  headerHeight.value = height
}
const footerHeightChange = (height) => {
  footerHeight.value = height
}
//获取屏幕尺寸
// 防抖函数
const debounceTimeout = ref(null)
const debounceResize = () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(() => {
        calculateHeight();
    }, 200);
};

const windowWidth = ref(window.innerWidth)
const calculateHeight = () => {
    windowWidth.value = window.innerWidth;
};
const isMobile = computed(() => {
  console.log(windowWidth.value,'宽度')
  return windowWidth.value < 768;
});
onMounted(() => {
    calculateHeight();
    window.addEventListener('resize', debounceResize);
})
</script>
<style lang="less" scoped>
.agri-service-cloud-container {
  width: 100%;
  min-height: 100vh;
  min-width: 1240px;
  // overflow: auto;
  .agri-Contain{
    box-sizing: content-box;
    min-width: 1240px;
    width: 100%;
    // background-color: #EEF3FE;
  }
}
</style>
